var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { parseRawJson, useFetch } from "../util";
import * as DOMData from './DOMData';
var AJAX_URL = window.red61.ajax_url;
var makeAjaxRequest = function (action, data) {
    if (data === void 0) { data = new FormData(); }
    return __awaiter(void 0, void 0, void 0, function () {
        var ajax_url, response, ret;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data.append('action', action);
                    ajax_url = DOMData.getRed61Config().ajax_url;
                    if (!ajax_url) {
                        throw new Error("Red61 Config not set globally, cannot make ajax request");
                    }
                    return [4 /*yield*/, fetch(ajax_url, {
                            method: 'POST',
                            body: data,
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Request failed with status ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    ret = _a.sent();
                    return [2 /*return*/, ret];
            }
        });
    });
};
export var useFetchSeatMap = function () { return useFetch('./seats-red-data.json'); };
export var addToBasket = function (ticketSelections, performanceId) { return __awaiter(void 0, void 0, void 0, function () {
    var seats, data;
    return __generator(this, function (_a) {
        seats = ticketSelections
            .map(function (_a) {
            var concessionId = _a.concessionId, priceBandId = _a.priceBandId, seatId = _a.seatId, promoCode = _a.promoCode;
            return ["".concat(priceBandId, "_").concat(concessionId), { seatId: seatId, promocode: promoCode }];
        })
            .reduce(function (rx, _a) {
            var key = _a[0], _b = _a[1], seatId = _b.seatId, promocode = _b.promocode;
            if (!rx[key]) {
                rx[key] = { seatIds: [] };
            }
            rx[key].seatIds.push(seatId);
            if (promocode && !rx[key].promocode) {
                rx[key].promocode = promocode;
            }
            return rx;
        }, {});
        data = new FormData();
        data.append('performanceId', performanceId);
        Object.entries(seats).forEach(function (_a) {
            var key = _a[0], _b = _a[1], seatIds = _b.seatIds, promocode = _b.promocode;
            data.append("seats[".concat(key, "]"), seatIds.join(','));
            data.append("qty[".concat(key, "]"), seatIds.length.toString());
            if (promocode) {
                data.append("promocode[".concat(key, "]"), promocode);
            }
        });
        return [2 /*return*/, makeAjaxRequest('add_to_basket', data)];
    });
}); };
export var removeFromBasket = function (seatId, performanceId) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        data.append('performanceId', performanceId);
        data.append('productId', seatId.toString());
        return [2 /*return*/, makeAjaxRequest('remove_seat_from_basket', data)];
    });
}); };
export var getSeatMap = function (performanceId, timestamp) { return __awaiter(void 0, void 0, void 0, function () {
    var data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = new FormData();
                data.append('performanceId', performanceId);
                if (timestamp) {
                    data.append('timestamp', timestamp);
                }
                return [4 /*yield*/, makeAjaxRequest('get_seating_plan', data)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, parseRawJson(response)];
        }
    });
}); };
export var getBasketItemsForPerformance = function (performanceId) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = new FormData();
                data.append('performanceId', performanceId);
                return [4 /*yield*/, makeAjaxRequest('get_basket_items', data)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
